import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { isEmpty } from 'ramda';
import { parseQueryString } from "../../utils/formatters";
import { fetchLoanApplicationFromToken, fetchLoanApplicationPrePopData, fireDtmController } from "../../actions/loanApplicationActions";
import { getLoanApplication } from "../../selectors";
import Banner from "./Banner/banner";
import Header from "./Header/header";
import ComboAppForm from "./ComboAppForm/comboAppForm";
import Notification from '../Notification/notification';
import { marketCodeChanged } from "../../actions";
import ValueStatement from "./ValueStatement/valueStatement";
import { MarketCodes } from "../../marketCodes";

export class ComboAppPage extends React.Component {

  componentWillMount() {
    const queryObject = parseQueryString(this.props.location.search);

    if(window.isToggleOn('integration_with_credit_karma')) {
      switch (this.props.affiliateName) {
      case MarketCodes.LENDING_TREE:
        this.props.marketCodeChanged(this.props.affiliateName);
        this.props.fetchLoanApplicationPrePopData(queryObject.token, queryObject.apr, queryObject.termInMonths);
        this.props.fireDtmController();
        return;
      case MarketCodes.CREDIT_KARMA:
        if(window.isToggleOff('cl_show_interstitial_page')) {
          this.props.marketCodeChanged(this.props.affiliateName);
          this.props.fetchLoanApplicationPrePopData(queryObject.token, queryObject.apr, queryObject.termInMonths);
        }
        this.props.fireDtmController();
        return;
      default:
        return;
      }
    } else {
      switch (this.props.affiliateName) {
      case MarketCodes.LENDING_TREE:
        this.props.marketCodeChanged(this.props.affiliateName);
        this.props.fetchLoanApplicationFromToken(queryObject.token);
        return;
      case MarketCodes.CREDIT_KARMA:
        this.props.fetchLoanApplicationPrePopData(queryObject.token, queryObject.apr, queryObject.termInMonths);
        return;
      default:
        return;
      }
    }
  }

  render() {
    const { loanApplication } = this.props;

    return isEmpty(loanApplication) ?
      (<article/>) :
      (<article>
        <div className={"container-fluid"}>
          <Banner bannerDetails={this.props.bannerDetails} />
          <ValueStatement firstName={loanApplication.applicantName.firstName} loanAmount={loanApplication.loanAmount.amount} />
          <Header
            loanAmount={loanApplication.loanAmount.amount}
            loanApr={loanApplication.apr}
            months={loanApplication.termInMonths}
            monthlyAmount={loanApplication.monthlyPayment.amount}/>
          <ComboAppForm/>
        </div>
        <Notification/>
      </article>);
  }
}

const mapStateToProps = (state) => ({
  loanApplication: getLoanApplication(state)
});

const mapDispatchToProps = {
  fetchLoanApplicationFromToken, fetchLoanApplicationPrePopData, marketCodeChanged, fireDtmController
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ComboAppPage));
